export default class TransactionUpdateActions {

    static NEW_DATA = 'NEW_DATA';
    static UPDATE_DATA='UPDATE_DATA';
    static SHOW_DATA='SHOW_DATA';
    static VIEW_DATA='VIEW_DATA';
    static DELETE_DATA='DELETE_DATA';
    static ON_SUBMIT='ON_SUBMIT';
    static ERROR_DATA='ERROR_DATA';
    static PROCESS_DATA='PROCESS_DATA';
    static RESET_DATA='RESET_DATA';
    static GET_HELPER_BRANCH='GET_HELPER_BRANCH';
    static SUCCESS_DATA='SUCCESS_DATA';
    static ERROR_SERVER='ERROR_SERVER';
    static RESET_LIST='RESET_LIST';
    static APPROVE='APPROVE';
    static REJECT='REJECT';
    static submit(){
      return {
        type: TransactionUpdateActions.ON_SUBMIT
      };
    }
  
    static create(data) {
      return {
        type: TransactionUpdateActions.NEW_DATA,
        payload: data
      };
    }
  
    static update(data) {
      return {
        type: TransactionUpdateActions.UPDATE_DATA,
        payload: data
      };
    }
  
    static view(data) {
      return {
        type: TransactionUpdateActions.VIEW_DATA,
        payload: data
      };
    }
  
    static delete(data) {
      return {
        type: TransactionUpdateActions.DELETE_DATA
      };
    }
  
    static list(data) {
      return {
        type: TransactionUpdateActions.SHOW_DATA,
        payload: data
      };
    }
    static resetList() {
      return {
        type: TransactionUpdateActions.RESET_LIST
      };
    }
    static error(error){
      return {
        type: TransactionUpdateActions.ERROR_DATA,
        payload: error
      };
    }
    static success(){
      return {
        type: TransactionUpdateActions.SUCCESS_DATA,
      };
    }
    static process(){
      return {
        type: TransactionUpdateActions.PROCESS_DATA,
      };
    }
    static reset(){
      return {
        type: TransactionUpdateActions.RESET_DATA,
      };
    }
    static helper(data){
      return {
        type: TransactionUpdateActions.GET_HELPER_BRANCH,
        payload:data
      };
    }
    static errorInternal(error){
      return {
        type: TransactionUpdateActions.ERROR_SERVER,
        payload: error
      };
    }
    static approve() {
      return {
        type: TransactionUpdateActions.APPROVE
      };
    }
    static reject() {
      return {
        type: TransactionUpdateActions.REJECT
      };
    }
  }